// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/users.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/collapse.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/expand.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meetingPageTasks {
    background: #FFFFFF;
    border-radius: 8px;
    border: 0.5px solid rgba(0, 0, 0, 0.08);
    overflow: hidden;
    margin-bottom: 12px;
}

.meetingPageTasks_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s ease;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);
}

.meetingPageTasks_header:hover {
    background-color: rgba(0, 0, 0, 0.02);
}

.meetingPageTasks_title_wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.meetingPageTasks_title {
    font-size: calc(15px * var(--fontScaler));
    font-weight: 500;
    color: #1D1D1F;
}

.meetingPageTasks_filter_icon {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s ease;
}

.meetingPageTasks_filter_icon:hover {
    opacity: 1;
}

.meetingPageTasks_filter_icon--active {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    opacity: 0.7;
}

.meetingPageTasks_filter_icon--active:hover {
    opacity: 1;
}

.meetingPageTasks_toggle {
    display: flex;
    align-items: center;
    justify-content: center;
}

.meetingPageTasks_toggle_icon {
    width: 16px;
    height: 16px;
    position: relative;
}

.meetingPageTasks_toggle_icon::before,
.meetingPageTasks_toggle_icon::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    transition: opacity 0.2s ease;
    opacity: 0.6;
}

.meetingPageTasks_toggle_icon::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.meetingPageTasks_toggle_icon::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    opacity: 0;
}

.meetingPageTasks--collapsed .meetingPageTasks_toggle_icon::before {
    opacity: 0;
}

.meetingPageTasks--collapsed .meetingPageTasks_toggle_icon::after {
    opacity: 0.6;
}

.meetingPageTasks_drop {
    display: grid;
    grid-template-rows: 1fr;
    transition: grid-template-rows 200ms cubic-bezier(0.075, 0.82, 0.165, 1);
    overflow: hidden;
}

.meetingPageTasks--collapsed .meetingPageTasks_drop {
    grid-template-rows: 0fr;
}

.meetingPageTasks_drop_content {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
}

.meetingPageTasks_actions {
    padding: 12px 16px;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);
}

.meetingPageTasks_add_wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: opacity 0.2s ease;
    opacity: 0.7;
}

.meetingPageTasks_add_wrapper:hover {
    opacity: 1;
}

.meetingPageTasks_add_icon {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: 11px;
    background-position: center;
    background-repeat: no-repeat;
}

.meetingPageTasks_add_text {
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    color: #1D1D1F;
}

.meetingPageTasks_loading {
    text-align: center;
    color: #86868B;
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    padding: 20px 16px;
}

.meetingPageTasks_content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    max-height: 400px;
    padding: 8px 16px;
}

.meetingPageTasks_list {
    display: flex;
    flex-direction: column;
    gap: 0;
}

/* Scrollbar - macOS style */
.meetingPageTasks_content::-webkit-scrollbar {
    width: 6px;
}

.meetingPageTasks_content::-webkit-scrollbar-track {
    background: transparent;
}

.meetingPageTasks_content::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 4px;
}

.meetingPageTasks_content::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.25);
}
`, "",{"version":3,"sources":["webpack://./src/pages/meetingPage/components/meetingPageTasks/MeetingPageTasks.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAoD;IACpD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,yDAAwD;AAC5D;;AAEA;IACI,yDAAsD;IACtD,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,wEAAwE;IACxE,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAmD;IACnD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA,4BAA4B;AAC5B;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC","sourcesContent":[".meetingPageTasks {\n    background: #FFFFFF;\n    border-radius: 8px;\n    border: 0.5px solid rgba(0, 0, 0, 0.08);\n    overflow: hidden;\n    margin-bottom: 12px;\n}\n\n.meetingPageTasks_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    cursor: pointer;\n    user-select: none;\n    transition: background-color 0.2s ease;\n    border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);\n}\n\n.meetingPageTasks_header:hover {\n    background-color: rgba(0, 0, 0, 0.02);\n}\n\n.meetingPageTasks_title_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.meetingPageTasks_title {\n    font-size: calc(15px * var(--fontScaler));\n    font-weight: 500;\n    color: #1D1D1F;\n}\n\n.meetingPageTasks_filter_icon {\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/user.svg');\n    background-size: 16px;\n    background-position: center;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.2s ease;\n}\n\n.meetingPageTasks_filter_icon:hover {\n    opacity: 1;\n}\n\n.meetingPageTasks_filter_icon--active {\n    background-image: url('../../../../assets/users.svg');\n    opacity: 0.7;\n}\n\n.meetingPageTasks_filter_icon--active:hover {\n    opacity: 1;\n}\n\n.meetingPageTasks_toggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.meetingPageTasks_toggle_icon {\n    width: 16px;\n    height: 16px;\n    position: relative;\n}\n\n.meetingPageTasks_toggle_icon::before,\n.meetingPageTasks_toggle_icon::after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    transition: opacity 0.2s ease;\n    opacity: 0.6;\n}\n\n.meetingPageTasks_toggle_icon::before {\n    background-image: url('../../../../assets/collapse.svg');\n}\n\n.meetingPageTasks_toggle_icon::after {\n    background-image: url('../../../../assets/expand.svg');\n    opacity: 0;\n}\n\n.meetingPageTasks--collapsed .meetingPageTasks_toggle_icon::before {\n    opacity: 0;\n}\n\n.meetingPageTasks--collapsed .meetingPageTasks_toggle_icon::after {\n    opacity: 0.6;\n}\n\n.meetingPageTasks_drop {\n    display: grid;\n    grid-template-rows: 1fr;\n    transition: grid-template-rows 200ms cubic-bezier(0.075, 0.82, 0.165, 1);\n    overflow: hidden;\n}\n\n.meetingPageTasks--collapsed .meetingPageTasks_drop {\n    grid-template-rows: 0fr;\n}\n\n.meetingPageTasks_drop_content {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.meetingPageTasks_actions {\n    padding: 12px 16px;\n    border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);\n}\n\n.meetingPageTasks_add_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n    transition: opacity 0.2s ease;\n    opacity: 0.7;\n}\n\n.meetingPageTasks_add_wrapper:hover {\n    opacity: 1;\n}\n\n.meetingPageTasks_add_icon {\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/add.svg');\n    background-size: 11px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.meetingPageTasks_add_text {\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    color: #1D1D1F;\n}\n\n.meetingPageTasks_loading {\n    text-align: center;\n    color: #86868B;\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    padding: 20px 16px;\n}\n\n.meetingPageTasks_content {\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    max-height: 400px;\n    padding: 8px 16px;\n}\n\n.meetingPageTasks_list {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n/* Scrollbar - macOS style */\n.meetingPageTasks_content::-webkit-scrollbar {\n    width: 6px;\n}\n\n.meetingPageTasks_content::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.meetingPageTasks_content::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.15);\n    border-radius: 4px;\n}\n\n.meetingPageTasks_content::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 0, 0, 0.25);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
